import { useRouter } from "next/router";
import { UseFormReturn, useForm } from "react-hook-form";

import { useTranslation } from "../../core/translation.core";
import MagnifyingIcon from "../../icons/magnifying.icon";
import { MaterialListFilter } from "../../types/material";
import CategorySelectorComp from "../category/categorySelector.comp";
import { FancyTextInputWithIcon } from "../reuseables/form.comp";

interface DummyForm {
  search: string;
}

export default function MaterialListFilterComp({ methods }: { methods: UseFormReturn<MaterialListFilter, any> }) {
  const { t, msg } = useTranslation();
  const { push, query } = useRouter();
  const dummyMethods = useForm<DummyForm>({
    defaultValues: {
      search: methods.getValues("search"),
    },
  });

  function onSubmit(data: DummyForm) {
    methods.setValue("search", data.search);

    if (methods.getValues("page") !== 1) {
      push({
        pathname: "/materials",
        query: { page: 1 },
      });
    }
  }

  return (
    <section data-type="section" className="space-y-4">
      <form onSubmit={dummyMethods.handleSubmit(onSubmit)}>
        <div id="select-category" className="grid grid-cols-[auto_100px] gap-2">
          {/* <CategorySelectorComp methods={methods} name="categoryIds" labelMaxLength={20} /> */}
          <FancyTextInputWithIcon
            register={() => dummyMethods.register("search")}
            placeholder={t(msg.material.searchMaterial)}
            icon={<MagnifyingIcon />}
            className="grow bg-admin-bg-blue"
          />
          <input type="submit" value={t(msg.general.search)} className="h-[34px]" />
        </div>
      </form>
    </section>
  );
}
